export const SPINNER_DELAY = 1000



// WEBPACK FOOTER //
// ./src/constants/dc-constants.js